import styled, { css } from 'styled-components';
import { maxWidth, minWidth } from '@/assets/styles/mixins.css';
import vars from '@/assets/styles/vars';
import Button from '@/components/styles/StyledButton';

const Directions = styled.div`
  padding-bottom: 50px;

  ${maxWidth(vars.breakpoints.tablet)`
    padding-bottom:30px;
  `}

  ${(props) =>
    props.size == 'mid' &&
    css`
      padding-bottom:35px;
    `}

  ${(props) =>
    props.center &&
    css`
    .swiper-wrapper {
      justify-content:center;

      ${maxWidth(vars.breakpoints.tablet)`
        justify-content:unset;
      `}
    }
    `}
`;

Directions.Content = styled.div`
  .swiper-container {
    overflow: visible;
  }
  .swiper-wrapper {
    row-gap: 10px;
    flex-wrap: wrap;

    ${maxWidth(vars.breakpoints.tablet)`
    flex-wrap: nowrap;
    `}

    ${minWidth(vars.breakpoints.tablet + 1)`
    transform: none !important;
    height: 100% !important;
    `}
  }
`;

Directions.Item = styled.div`
  display: flex;
  width: fit-content;
  margin-right: 10px;

  ${Button} {
    &:focus,
    &:active {
      background: var(--color-decor);
      color:#fff;
    }
  }
`;

export default Directions;
